import { HttpErrorResponse } from '@angular/common/http';

export type HttpLoadState = 'not-found' | 'forbidden' | 'error';

/// Detay ekranı yükleme hatasını ekran durumuna çevirir: 404/400 → bulunamadı (geçersiz id 400 döner),
/// 403 → yetki yok, diğerleri → hata.
export function httpLoadState(err: unknown): HttpLoadState {
  const status = err instanceof HttpErrorResponse ? err.status : 0;
  if (status === 404 || status === 400) return 'not-found';
  if (status === 403) return 'forbidden';
  return 'error';
}
